module.exports = __webpack_public_path__ + "static/media/4.a44abe30.jpg";